export default [
  // 活动详情
  {
    path: 'activityDetail',
    component: () => import('@/views/modules/activity/activityDetail'),
    name: 'activityDetail',
    meta: { title: '活动详情', needToken: false }
  },
  // 更多活动
  {
    path: 'actuvutyGoodList',
    component: () => import('@/views/modules/activity/actuvutyGoodList'),
    name: 'actuvutyGoodList',
    meta: { title: '更多', needToken: false }
  },
  {
    path: 'goodList',
    component: () => import('@/views/modules/activity/goodList'),
    name: 'goodList',
    meta: { title: '更多', needToken: false }
  },
  // 秒杀活动列表
  {
    path: 'seckillList',
    component: () => import('@/views/modules/activity/seckillList'),
    name: 'seckillList',
    meta: { title: '秒杀活动列表', needToken: false }
  },
  // 秒杀活动详情
  {
    path: 'seckillDetail',
    component: () => import('@/views/modules/activity/seckillDetail'),
    name: 'seckillDetail',
    meta: { title: '秒杀活动详情', needToken: false }
  },
  {
    path: 'customActivity',
    component: () => import('@/views/modules/activity/customActivity'),
    name: 'customActivity',
    meta: {
      title: 'PLANTMATE', needToken: false
    }
  }
]
